import { render, staticRenderFns } from "./PharmacyReferral.vue?vue&type=template&id=714b0c02"
import script from "./PharmacyReferral.vue?vue&type=script&lang=js"
export * from "./PharmacyReferral.vue?vue&type=script&lang=js"
import style0 from "./PharmacyReferral.vue?vue&type=style&index=0&id=714b0c02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports